import { HOST_OVERRIDES, HOST_PREFIX_OVERRIDES } from './host-overrides';

export function resolveRpcHost(rpcPath: string, env: string): string {
  const fullService = rpcPath.split('/')[0];

  if (HOST_OVERRIDES[fullService]) {
    const host = HOST_OVERRIDES[fullService].replace('${ENV}', env);
    return host.startsWith('https://') ? host : `https://${host}`;
  }

  const parts = fullService.split('.');
  const prefix = parts
    .slice(0, -1)
    .filter((p) => !/^v\d+/.test(p))
    .join('-')
    .replace(/_/g, '-');

  const resolved = HOST_PREFIX_OVERRIDES[prefix] ?? prefix;

  return `https://${resolved}-${env}.apigateway.co`;
}
